export const useIsIframed = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
